import React from 'react';
import cx from 'classnames';
import styles from './FormBreadCrumbs.module.scss';

const FormBreadCrumbs = ({
  section,
}) => {
  return (
    <div className={styles.breadcrumbs}>
      <span className={cx(styles.crumb, section === 'GEGEVENS' && styles.active)}>1. gegevens</span>
      <span className={cx(styles.crumb, section === 'ZWANGERSCHAP' && styles.active)}>2. zwangerschap</span>
      <span className={cx(styles.crumb, section === 'CHECKOUT' && styles.active)}>3. akkoord en betaling</span>
    </div>
  )
}

export default FormBreadCrumbs;